import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CheckIcon from '@mui/icons-material/Check';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, FormControl, MenuItem, SelectChangeEvent } from '@mui/material';

import { StyledSortSelect, StyledSortTitle } from './styled';

export interface ISortProps {
	value: string;
	options: { label: string; value: string }[];
	onSort: (value: string) => void;
	title?: string;
}

function Sort({ value = 'latest', options, onSort, title }: ISortProps) {
	const [selectedValue, setSelectedValue] = useState<string>(value);
	const { t } = useTranslation();

	const handleChange = (event: SelectChangeEvent<string>) => {
		const newValue = event.target.value;
		setSelectedValue(newValue);
		onSort(newValue);
	};

	const renderIconComponent = (props: any) => (
		<KeyboardArrowDownIcon
			sx={{
				transition: 'all .2s',
				strokeWidth: '0.5px',
			}}
			{...props}
		/>
	);

	return (
		<FormControl variant="outlined">
			<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
				<StyledSortTitle>{title || t('shared.sortBy')}: </StyledSortTitle>
				<StyledSortSelect
					value={selectedValue}
					onChange={handleChange}
					variant="standard"
					displayEmpty
					inputProps={{ 'aria-label': 'Without label' }}
					disableUnderline
					IconComponent={renderIconComponent}
					sx={{ fontWeight: 600 }}
					renderValue={(selected) => {
						const selectedOption = options.find((option) => option.value === selected);
						return selectedOption ? selectedOption.label : '';
					}}
					MenuProps={{
						PaperProps: {
							sx: {
								width: '220px',
								background: 'none',
								backdropFilter: 'blur(10px)',
							},
						},
						anchorOrigin: {
							vertical: 'bottom',
							horizontal: 'right',
						},
						transformOrigin: {
							vertical: 'top',
							horizontal: 'right',
						},
					}}
				>
					{options.map((option) => (
						<MenuItem key={option.value} value={option.value}>
							{option.label}
							{selectedValue === option.value && <CheckIcon style={{ marginLeft: 'auto' }} />}
						</MenuItem>
					))}
				</StyledSortSelect>
			</Box>
		</FormControl>
	);
}

export default Sort;
